const LOGIN_CARD_MAX_WIDTH_PX = 430;
const LOGIN_CARD_MIN_WIDTH_PX = 288;
const LOGIN_CARD_HORIZONTAL_GUTTER_PX = 32;

export function resolveLoginCardMaxWidth(viewportWidth: number): number {
  if (!Number.isFinite(viewportWidth)) return LOGIN_CARD_MAX_WIDTH_PX;
  const availableWidth = Math.floor(
    viewportWidth - LOGIN_CARD_HORIZONTAL_GUTTER_PX,
  );
  return Math.min(
    LOGIN_CARD_MAX_WIDTH_PX,
    Math.max(LOGIN_CARD_MIN_WIDTH_PX, availableWidth),
  );
}
